import React, {Component} from "react";
import axios from "axios";
import AuthService from "../../../AuthService";

import loader from "../../../img/loader.gif";
import Moment from "moment";
import Dialog from "../../util/Dialog";
import ExtraDialog from "../../backoffice/ExtraDialog";

class SpecificBlockPrice extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            croisiereId: this.props.blockItem.values[0],
            result: null,
            data: '',
            extrasDialog: false
        }
        const e = {target: {name: name, value: this.props.blockItem.values[0]}};

        this.props.onChange(e);
        this.change = this.change.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    change(e) {
        if (e.target.name==='nbOptions') {
            this.loadData();
        }
        this.props.onChange(e);
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        await axios.post(AuthService.getUrl('/getCroisiereBill'), {croisiere: {id: this.state.croisiereId}}, AuthService.getAuthHeader()).then(res => {

            if (res.data.data.errors !== undefined) {
                this.setState({
                    errors: res.data.errors
                });
                return ;
            }

            this.setState({
                result: res.return,
                data: res.data.data
            });
        });
    }

    async triggerPayement(total) {
        if (window.confirm('Etes-vous sur de vouloir déclancher un paiement?')) {
            await axios.post(AuthService.getUrl('/triggerPayement'), {croisiere: {id: this.state.croisiereId}, amount: total}, AuthService.getAuthHeader()).then(res => {
                document.location = "/admin/croisiere/" + this.state.croisiereId;
            });
        }
    }

    addExtra(e) {
        this.props.externalCall("extrasDialog");
    }

    closeDialog(e, validMessage, errorMessage) {
        document.location = "/admin/croisiere/" + this.state.croisiereId;
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            let total = (this.state.data.croisiere.prix !== null) ? this.state.data.croisiere.prix : 0;
            return (
                <div id="croisiere-bill">
                    <input type="text" id="nbOptions" name="nbOptions" value="" onChange={this.change} style={{"display" : "none"}} />
                    <div id="croisiere-bill-title">
                        Détail Facturation
                        <button type="button" className="addButton" onClick={() => this.setState({extrasDialog: true})}
                                style={{"float": "right", "width": "180px", "padding": "6px 12px", "color": "#FFFFFF", "background": "url('/img/icon/icon_add.png') 0px center no-repeat"}}>Ajouter extra</button>
                    </div>
                    <div className="croisiere-bill-line">
                        <div className="croisiere-bill-cell">{this.state.data.croisiere.nombrePassager}x {this.state.data.croisiere.croisiereType.label}</div>
                        <div className="croisiere-bill-cell2">{total.toString().slice(0, total.toString().length-2) + "," + total.toString().slice(-2)} €</div>
                    </div>

                    {this.state.data.croisiereOptions.map(option => {
                        if (!!option.nbCharged) {
                            let price = option.nbCharged * option.price;
                            total += price;

                            if (price !== 0) {
                                return (
                                    <div className="croisiere-bill-line">
                                        <div className="croisiere-bill-cell">{option.nbCharged}x {option.croisiereOption.label}</div>
                                        <div className="croisiere-bill-cell2">{price.toString().slice(0, price.toString().length-2) + "," + price.toString().slice(-2)} €</div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="croisiere-bill-line">
                                        <div className="croisiere-bill-cell">{option.nbCharged}x {option.croisiereOption.label}</div>
                                        <div className="croisiere-bill-cell2">0,00 €</div>
                                    </div>
                                );
                            }
                        }
                    })}

                    {this.state.data.croisiereExtras.map(extra => {
                        total += extra.amount;
                        return (
                            <div className="croisiere-bill-line croisiere-bill-line-hover" onClick={() => this.setState({extrasDialog: true, croisiereExtraId: extra.id})}>
                                <div className="croisiere-bill-cell">{extra.label}</div>
                                <div className="croisiere-bill-cell2">{extra.amount.toString().slice(0, extra.amount.toString().length-2) + "," + extra.amount.toString().slice(-2)} €</div>
                            </div>
                        );
                    })}

                    <div className="croisiere-bill-line">
                        <div className="croisiere-bill-cell2">Total : {total.toString().slice(0, total.toString().length-2) + "," + total.toString().slice(-2)} €</div>
                    </div>

                    {!!this.state.data.transactions && this.state.data.transactions.length > 0 &&
                    <React.Fragment>
                        <div className="croisiere-bill-line" style={{"color": "#224250", "background": "#FFFFFF", "fontSize": "15px"}}>Transactions banque</div>
                        {this.state.data.transactions.map(transaction => {
                            if (transaction.refTransactionStatutId !==3) {
                                total -= transaction.amount;
                            }
                            return (
                                <div className="croisiere-bill-line">
                                    <div className="croisiere-bill-cell">{transaction.uuid}</div>
                                    <div style={{
                                        "width": "100%",
                                        "fontFamily": "'SourceSansPro-bold'"
                                    }}> {transaction.refTransactionStatutId == 1 ? 'Payé' : transaction.refTransactionStatutId == 2 ? 'En cours' : 'Refusé'} le {Moment(transaction.dateCreate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}</div>
                                    <div className="croisiere-bill-cell2">{transaction.amount.toString().slice(0, transaction.amount.toString().length - 2) + "," + transaction.amount.toString().slice(-2)} €</div>
                                </div>
                            );
                        })}
                    </React.Fragment>
                    }

                    {total > 0 &&
                    <React.Fragment>
                        <div className="croisiere-bill-line">
                            <div className="croisiere-bill-cell2">Reste a payer : {total.toString().slice(0, total.toString().length-2) + "," + total.toString().slice(-2)} €</div>
                        </div>
                        {this.state.data.croisiere.clientToken !== null &&
                        <React.Fragment>
                            <button type="button" className="validButton" style={{"float": "right", "fontSize": "13px"}} onClick={() => this.triggerPayement(total)}>Facturer 100%</button>
                            {!this.state.data.transactions || this.state.data.transactions.length === 0 &&
                            <button type="button" className="validButton" style={{"float": "right", "marginRight": "20px", "fontSize": "13px"}} onClick={() => this.triggerPayement(total / 2)}>Facturer 50%</button>
                            }
                        </React.Fragment>
                        }
                    </React.Fragment>
                    }
                    {total < 0 &&
                    <div className="croisiere-bill-line">
                        <div className="croisiere-bill-cell2">Vous avez facturé un surplus : {total.toString().slice(0, (total).toString().length-2) + "," + total.toString().slice(-2)} €</div>
                    </div>
                    }

                    {this.state.extrasDialog &&
                    <Dialog close={this.closeDialog}>
                        <ExtraDialog
                            closeDialog={this.closeDialog}
                            croisiereId={this.state.croisiereId}
                            croisiereExtraId={this.state.croisiereExtraId}/>
                    </Dialog>
                    }
                </div>
            )
        }
    }
}

export default SpecificBlockPrice;
